import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';

import flagVariantOutline from '@iconify/icons-mdi/flag-variant-outline';
import flagVariant from '@iconify/icons-mdi/flag-variant';
// material
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { reportTripsActions } from '../../store';
import { editItem } from '../../fetch';
import updateFlightList from './updateFlightList';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';

// ----------------------------------------------------------------------

FlightAddFlag.propTypes = {
  reportTrip: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default function FlightAddFlag({ reportTrip, disabled }) {
  const t = useTranslation();
  const dispatch = useDispatch();
  const ref = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const session = useSelector(selectSession);

  const [isOpen, setIsOpen] = useState(false);

  const handleAddFlag = async (value) => {
    const body = {
      id: reportTrip.affectationVolsId,
      deviceId: reportTrip.deviceId,
      piloteId: reportTrip.driverUniqueId,
      instructeurId: reportTrip.instructeurUniqueId,
      startTime: reportTrip.startTime,
      endTime: reportTrip.endTime,
      groupId: reportTrip.groupId,
      attributes: {},
      comment: reportTrip.commentAffectationVols,
      flag: value,
      favorite: reportTrip.favoriteAffectationVols,
      remarquableTrace: reportTrip.pointRemarquableTrace > 0
    };

    const response = await editItem('affectationVols', body.id, body);
    if (response.ok) {
      enqueueSnackbar(t('FL_Flags_Success'), {
        variant: 'success'
      });
      dispatch(reportTripsActions.update(await updateFlightList(body)));
    } else {
      const error = await response.text();
      const message = error.slice(0, error.indexOf('-'));
      enqueueSnackbar(message, { variant: 'error' });
    }

    setIsOpen(false);
  };
  return (
    <>
      <MenuItem
        ref={ref}
        onClick={() => setIsOpen(true)}
        sx={{ color: 'text.secondary' }}
        disabled={disabled}
      >
        <ListItemIcon>
          {reportTrip.flagAffectationVols === null && (
            <Icon icon={flagVariantOutline} width={24} height={24} />
          )}
          {reportTrip.flagAffectationVols === 'revoir' && (
            <Icon icon={flagVariant} width={24} height={24} color="#FF9BFF" />
          )}
          {reportTrip.flagAffectationVols === 'resolu' && (
            <Icon icon={flagVariant} width={24} height={24} color="#00FF00" />
          )}
          {reportTrip.flagAffectationVols === 'etude' && (
            <Icon icon={flagVariant} width={24} height={24} color="#FEC802" />
          )}
          {reportTrip.flagAffectationVols === 'signaler' && (
            <Icon icon={flagVariant} width={24} height={24} color="#FF0000" />
          )}
          {reportTrip.flagAffectationVols === 'concour' && (
            <Icon icon={flagVariant} width={24} height={24} color="#9900FF" />
          )}
        </ListItemIcon>
        <ListItemText primary={t('FL_Menu_Flag')} primaryTypographyProps={{ variant: 'body2' }} />
      </MenuItem>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 230, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => handleAddFlag('concour')} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Icon icon={flagVariant} width={24} height={24} color="#9900FF" />
          </ListItemIcon>
          <ListItemText
            primary={t('FL_Flags_Competition')}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
        <MenuItem onClick={() => handleAddFlag('revoir')} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Icon icon={flagVariant} width={24} height={24} color="#FF9BFF" />
          </ListItemIcon>
          <ListItemText
            primary={t('FL_Flags_Review')}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
        {session.administrator && (
          <MenuItem onClick={() => handleAddFlag('resolu')} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={flagVariant} width={24} height={24} color="#00FF00" />
            </ListItemIcon>
            <ListItemText
              primary={t('FL_Flags_Solve')}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
        )}
        {session.administrator && (
          <MenuItem onClick={() => handleAddFlag('etude')} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={flagVariant} width={24} height={24} color="#FEC802" />
            </ListItemIcon>
            <ListItemText
              primary={t('FL_Flags_Progress')}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
        )}
        <MenuItem onClick={() => handleAddFlag('signaler')} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Icon icon={flagVariant} width={24} height={24} color="#FF0000" />
          </ListItemIcon>
          <ListItemText
            primary={t('FL_Flags_Anomaly')}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
        <MenuItem onClick={() => handleAddFlag(null)} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Icon icon={flagVariantOutline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary={t('FL_Flags_Remove')}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}
